/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import useQueryParams from './useQueryParams'
import { useMemo } from 'react'

function useParsedQueryParam<T> (name: string, parser: (value?: string | string[]) => T): T {
  const [queryParams] = useQueryParams()
  return useMemo(() => {
    if (queryParams[name] != null && queryParams[name] !== '') {
      return parser(queryParams[name])
    }
    return null
  }, [name, parser, queryParams])
}

export default useParsedQueryParam
